import { Desktop, LargeMobile, SmallMobile } from 'styles/MediaQueries';
import { NAVY, SKY, WHITE_TEXT } from 'styles/Colors';
import DynamicFooter from 'components/display/DynamicFooter';
import React, { memo } from 'react';

const HEADMAST_HEIGHT_DESKTOP = 61;
const HEADMAST_HEIGHT_MOBILE = 55;
const GRD_BCKGR_PAD_TOP_DESKTOP = '3.5rem';
const GRD_BCKGR_PAD_TOP_MOBILE = '2.75rem';
const GRD_BCKGR_MRG_BTTM = '2rem';
const GRD_BCKGR_HEIGHT_DESKTOP = `calc(100vh - ${HEADMAST_HEIGHT_DESKTOP}px)`;
const GRD_BCKGR_HEIGHT_MOBILE = `calc(100vh - ${HEADMAST_HEIGHT_MOBILE}px)`;
const WHT_BCKGR_HEIGHT_DESKTOP = `calc(${GRD_BCKGR_HEIGHT_DESKTOP} - ${GRD_BCKGR_PAD_TOP_DESKTOP} - ${GRD_BCKGR_MRG_BTTM})`;
const WHT_BCKGR_HEIGHT_MOBILE = `calc(${GRD_BCKGR_HEIGHT_MOBILE} - ${GRD_BCKGR_PAD_TOP_MOBILE} - ${GRD_BCKGR_MRG_BTTM})`;

const gradientBackgroundStyle = {
  background: `linear-gradient(${NAVY}, ${SKY})`,
  display: 'flex',
  flexDirection: 'column',

  minHeight: GRD_BCKGR_HEIGHT_MOBILE,
  padding: `${GRD_BCKGR_PAD_TOP_MOBILE} 0.5rem 0.75rem`,

  [Desktop]: {
    minHeight: GRD_BCKGR_HEIGHT_DESKTOP,
    padding: `${GRD_BCKGR_PAD_TOP_DESKTOP} 2.25rem 2.25rem`
  }
};

const whiteBackgroundStyle = {
  position: 'relative',
  background: WHITE_TEXT,
  minHeight: WHT_BCKGR_HEIGHT_MOBILE,
  width: '100%',
  display: 'flex',
  flex: '1',
  borderRadius: '3px',

  [Desktop]: {
    minHeight: WHT_BCKGR_HEIGHT_DESKTOP
  }
};

const contentStyle = {
  alignItems: 'center',
  borderRadius: 3,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Arimo',
  margin: 'auto',
  position: 'relative',
  padding: '1.25rem',

  [SmallMobile]: {
    padding: '1rem 0',
    maxWidth: '20rem'
  },

  [Desktop]: {
    padding: '2rem',
    maxWidth: '34rem'
  }
};

const iconContainerStyle = {
  alignItems: 'center',
  background: WHITE_TEXT,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  left: '50%',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  height: '4.8125rem',
  width: '4.8125rem',

  [LargeMobile]: {
    height: '4.125rem',
    width: '4.125rem'
  }
};

const iconStyle = {
  height: '3.25rem',
  width: '3.25rem',

  [LargeMobile]: {
    height: '2.75rem',
    width: '2.75rem'
  }
};

const additionalFooterStyle = {
  marginTop: GRD_BCKGR_MRG_BTTM
};

const FooterWithTopMargin = () => (
  <DynamicFooter additionalFooterStyle={additionalFooterStyle} />
);
const Footer = memo(FooterWithTopMargin);

function MainLayout({
  children,
  icon,
  additionalIconStyle = {},
  additionalStyle = {},
  additionalContentStyle = {},
  withFooter = true
}) {
  return (
    <div css={[gradientBackgroundStyle, additionalStyle]}>
      <div css={whiteBackgroundStyle}>
        {icon && (
          <div css={iconContainerStyle}>
            <div css={[iconStyle, additionalIconStyle]}>{icon}</div>
          </div>
        )}

        <div css={[contentStyle, additionalContentStyle]}>{children}</div>
      </div>

      {withFooter && <Footer />}
    </div>
  );
}

export default MainLayout;
